module.exports = __webpack_public_path__ + "static/fonts/notokr-medium.81bd542.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/font/notokr-medium.woff
// module id = fYE+
// module chunks = 0